import BaseState from "Engine/base/states/BaseState";

export default class JackpotGameOutState extends BaseState {
    start() {
        super.start();
        if (this.active)
            this.complete();
    }
}
